import { Guid } from '@web/utils';
import { WarehouseProductType } from '../enums/warehouse-product-type';
import { QuantityUnit } from '@web/shared/module/measurement';

export class WarehouseReceiptProductDetails {
  public constructor(
    private data: {
      batchNumber: string;
      brand: string;
      durabilityInformation: string;
      id: Guid;
      name: string;
      ownerId: Guid;
      promotion: boolean;
      quantity: number;
      sku: string;
      type: WarehouseProductType;
      unit: QuantityUnit;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get ownerId(): Guid {
    return this.data.ownerId;
  }

  public get type(): WarehouseProductType {
    return this.data.type;
  }

  public get sku(): string {
    return this.data.sku;
  }

  public get batchNumber(): string {
    return this.data.batchNumber;
  }

  public get name(): string {
    return this.data.name;
  }

  public get unit(): QuantityUnit {
    return this.data.unit;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get durabilityInformation(): string {
    return this.data.durabilityInformation;
  }

  public get brand(): string {
    return this.data.brand;
  }

  public get promotion(): boolean {
    return this.data.promotion;
  }
}
